import {Skeleton} from "@/components/ui/skeleton";

export function AdminLoading({lines = 4}: {lines?: number}) {
  return (
    <div className="space-y-3 py-2" aria-busy="true">
      {Array.from({length: lines}).map((_, i) => (
        <Skeleton key={i} className="h-10" style={{width: `${88 - i * 12}%`}} />
      ))}
    </div>
  );
}
